export default __webpack_public_path__ + "static/media/aurora-logo.611ea0f9.svg";